import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AppSection />
        <CommentsSection />
        <AboutSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <UpdatesSection />
        <CarouselSection />
        <IndexSection />
        <FAQSection />
        <ContactSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}